//mypreset.ts
import { definePreset, palette } from '@primeng/themes';
import Nora from '@primeng/themes/nora';
import Material from '@primeng/themes/material';
import { colorSets } from '@swimlane/ngx-charts';



/*
semantic: {

    colorScheme: {
      light: {
          primary: {
              color: '{violet.900}',
              inverseColor: '#ffffff',
              hoverColor: '{violet.800}',
              activeColor: '{violet.600}'
          },
          highlight: {
              background: '{violet.800}',
              focusBackground: '{violet.600}',
              color: '#ffffff',
              focusColor: '#ffffff'
          }
      },
      dark: {
        root:
        {
          color:  '{purple.50}',
          background: '{purple.900}',
        },
          primary: {
              color: '{purple.500}',
              inverseColor: '{violet.900}',
              hoverColor: '{violet.400}',
              activeColor: '{violet.300}'
          },
          highlight: {
              background: 'rgba(250, 250, 250, 0.5)',
              focusBackground: 'rgba(250, 250, 250, .24)',
              color: 'rgba(255,255,255,.87)',
              focusColor: 'rgba(255,255,255,.87)'
          }
      }

  }
      */


const Sortimentierenpreset = definePreset(Material, {

  components: {

    progressspinner:
    {

      colorScheme: {
        light: {
          root: {
            color:
            {
              one: '{indigo.500}',
              two: '{indigo.500}',
              three: '{indigo.500}',
              four: '{indigo.500}'
            },
          },
        },
        dark: {
          root: {
            color:
            {
              one: '{indigo.200}',
              two: '{indigo.200}',
              three: '{indigo.200}',
              four: '{indigo.200}'
            },
          },
        }

      }

    },
    checkbox:
    {
      disabled: {
        //#7863
        background: '{slate.400}',
      }
    },

    dialog:
    {
      header:
      {
        padding: 'var(--paddingControlLarge)',
        gap: 'var(--gapControlSmall)',
      },
      css: ({ dt }) => `
              .p-dialog-header {
                  background: var(--p-surface-100);
              }
              `,



    },
    tabView:
    {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      }
    },
    button:
    {
      root:
      {
        paddingX: 'var(--paddingControlMedium)',
        paddingY: 'var(--paddingControlMedium)',
      },
    },
    inputgroup: {
      addon:
      {
        padding: 'var(--paddingControlSmall)',
      },
    },
    inputnumber: {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      disabled:
      {
        background: 'var(--backgroundCommonContentDisabled)'
      }
    },
    textarea: {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
    },
    inputtext: {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      disabled:
      {
        background: 'var(--backgroundCommonContentDisabled)'
      }
    },
    autocomplete:
    {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      disabled:
      {
        background: 'var(--backgroundCommonContentDisabled)'
      }
    },
    datepicker:
    {
      panel:
      {
        padding: 'var(--paddingControlSmall)',
      },
      disabled:
      {
        background: 'var(--backgroundCommonContentDisabled)'
      }
    },
    multiselect:
    {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      option: {
        padding: 'var(--paddingControlSmall)',
      },
      list: {
        padding: 'var(--paddingControlSmall)',
        header: {
          padding: 'var(--paddingControlSmall)',
        }
      }
    },
    select: {


      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      option: {
        padding: 'var(--paddingControlSmall)',
      },
      list: {
        padding: 'var(--paddingControlSmall)',
        header: {
          padding: 'var(--paddingControlSmall)',
        }
      }
    },
    tree: {
      padding: 'var(--paddingControlSmall)',
      node: {
        padding: 'var(--paddingControltiny)',
      }
    },
    datatable:
    {

      header:
      {
        cell:
        {
          padding: 'var(--paddingControlCell) !important',
        }
      },
      body: {
        cell: {
          padding: 'var(--paddingControlCell)',
        },
      },
      css: ({ dt }) => `
              .p-datatable.p-datatable-striped .p-datatable-tbody > tr:nth-child(odd):not(.p-datatable-row-selected) {
    .p-datatable-frozen-column
  {
      background: ${dt('datatable.row.striped.background')};
  }
}

.p-datatable-hoverable
  .p-datatable-tbody
  > tr:not(.p-datatable-row-selected):hover {
  .p-datatable-frozen-column {
    background: ${dt('datatable.row.hover.background')};
  }
}
                `,

      colorScheme: {
        light: {
          // datatable
          header:
          {
            cell: {
              // background: '{slate.100}',
            }
          },
          row: {
            // p-datatable-row-selected
            selected:
            {
                background: '{violet.300}',
            },
            striped: {
              background: '{slate.50}',
            }
          }
        },
        dark:
        {
          border:
          {
            color: '{slate.750}',
          },
          column: {
            frozen:
            {
              hover:
              {
                background: '{violett.300}',
                color: '{slate.950}',
              }
            }


          },
          row: {

            frozen:
            {
              hover:
              {
                background: '{violett.300}',
                color: '{slate.950}',
              }
            },
            background: '{slate.900}',
            color: '{slate.50}',
            border:
            {
              color: '{slate.700}'
            },
            hover:
            {
              background: '{violett.300}',
              color: '{slate.950}',
            }
          },
          body: {

            frozen:
            {
              hover:
              {
                background: '{violett.300}',
                color: '{slate.950}',
              }
            },
            cell: {
              padding: 'var(--paddingControlCell)',
              hover:
              {

                background: '{violett.300}',
                color: '{slate.950}',
              },
              background: '{slate.900}',
              color: '{slate.50}',
              border:
              {
                color: '{slate.700}'
              },
              sm: {
                background: '{slate.900}',
                color: '{slate.50}',
              },
              lg: {
                background: '{slate.900}',
                color: '{slate.50}',
              }
            }
          },
          header:
          {
            call:
            {
              selectedBackground: '{indigo.100}',
              selected: {
                background: '{indigo.100}',
              }
            },
            background: '{slate.700}',
            color: '{slate.100}',
            border:
            {
              color: '{slate.400}'
            },
            frozen:
            {
              hover:
              {
                background: '{violett.300}',
                color: '{slate.950}',
              }
            },
            hover:
            {
              background: '{violett.300}',
              color: '{slate.950}',
            },

            cell: {
              padding: 'var(--paddingControlCell)',
              hover:
              {
                background: '{violett.300}',
                color: '{slate.950}',
              },
              background: '{slate.900}',
              color: '{slate.50}',
              border:
              {
                color: '{slate.700}'
              }
            }
          },
          footer:
          {
            hover:
            {
              background: '{violett.300}',
              color: '{slate.800}',
            },
            background: '{slate.700}',
            color: '{slate.0}',
            cell: {
              padding: 'var(--paddingControlCell)',
              background: '{slate.700}',
              color: '{slate.0}',
              border:
              {
                color: '{slate.700}'
              }
            }
          },

          content: {
            hover:
            {
              background: '{violett.300}',
              color: '{slate.950}',
            },
            background: '{slate.900}',
            color: '{slate.50}'
          }

        }
      }
    },
    paginator:
    {
      background: '{slate.50}'

    },
    panel:
    {
      padding: 'var(--paddingControlSmall)',
      header: {
        background: '{slate.50}',
        padding: 'var(--paddingControlSmall)',
      }
    },
    toolbar:
    {
      root: {
        padding: 'var(--paddingControlSmall)',
        gap: 'var(--gapControlSmall)',
      },
      background: '{slate.100}',
      submenu:
      {
        padding: 'var(--paddingControlSmall)',
        background: '{slate.50}',
        item:
        {
          padding: 'var(--paddingControlSmall)',
          background: '{slate.50}',
        }
      }
    },
    menubar:
    {
      background: '{slate.100}',
      submenu:
      {
        background: '{slate.50}',
        item:
        {
          background: '{slate.50}',
        }
      }
    },

    accordion:
    {
      header: {
        background: '{slate.100}',
        hover:
        {
          background: '{slate.200}',
        },
        active:
        {
          background: '{slate.100}',
          hover:
          {
            // background: '{slate.200}',
          },
        }
      }
    },
    togglebutton: {
      root:
      {
        paddingX: 'var(--paddingControlSmall)',
        paddingY: 'var(--paddingControlSmall)',
      },
      colorScheme: {
        light: {
          background: '{surface.200}',
          border: {
            color: '{indigo.600}'
          },
          checked:
          {
            background: '{indigo.100}',
            border: {
              color: '{indigo.300}'
            }
          }
        },
        dark: {

          background: '{slate.700}',
          color: '{indigo.50}',
          label:
          {
            background: '{slate.600}',
            color: '{indigo.50}',
          },
          icon: {
            color: '{slate.50}',
            checked:
            {
              color: '{slate.50}',
            },
            background: '{slate.800}',
            hover:
            {
              color: '{indigo.200}',
            }
          },
          hover:
          {
            color: '{indigo.50}',
            background: '{slate.700}',
            border: {
              color: '{indigo.600}'
            },

          },
          checked:
          {
            color: '{indigo.300}',
            background: '{slate.700}',
            content:
            {
              color: '{indigo.500}',
              background: '{slate.800}',
            },
            icon: {
              color: '{indigo.50}',
              background: '{slate.800}',
              hover:
              {
                color: '{indigo.50}',
              }
            },
            hover:
            {
              color: '{indigo.100}',
              background: '{slate.700}',
              border: {
                color: '{indigo.400}'
              }

            }
          }
        }
      },
    }
  },
  semantic: {

    colorScheme: {
      light: {
        primary: palette('{violet}'),
        highlight: {
          background: '{violet.800}',
          focusBackground: '{violet.600}',
          color: '#ffffff',
          focusColor: '#ffffff'
        }

      },
      dark: {

        autocomplete:
        {
          background: '{slate.800}',
          color: '{slate.50}',
          option:
          {
            background: '{slate.700}',
            color: '{slate.50}',
            border: {
              color: '{slate.500}',
            },
            focus:
            {
              background: '{slate.800}',
              color: '{indigo.50}',
            }
          },
          overlay:
          {
            background: '{slate.800}',
            color: '{slate.50}',
            border: {
              color: '{slate.500}',
            },
            content:
            {
              background: '{slate.700}',
              color: '{slate.50}',
            }
          },
          empty:
          {
            message: {
              background: '{zinc.800}',
              color: '{zinc.0}',
            }
          }
        },
        popover:
        {
          background: '{zinc.800}',
          color: '{zinc.0}',
          border:
          {
            color: '{slate.500}'
          },
          content:
          {

          }
        },
        inputgroup:
        {
          background: '{slate.900}',
          color: '{slate.50}',
          addon:
          {
            background: '{zinc.800}',
            color: '{slate.0}',
            border:
            {
              color: '{slate.800}',
            }
          }
        },
        formField: {
          hoverBorderColor: '{primary.color}',
          color: '{slate.50}',
          background: '{slate.900}',
        },

        text: {

        },

        components: {

          formgroup:
          {
            background: '{slate.800}',
            color: '{slate.50}',
          },
          form: {
            field: {
              hoverBorderColor: '{primary.color}',
              color: '{slate.50}',
              background: '{slate.900}',
            }
          },

          inputgroup:
          {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          splitter:
          {
            background: '{slate.800}',
            color: '{slate.50}',
            border:
            {
              color: '{slate.800}',
            }
          },
          tabs:
          {
            tab:
            {
              color: '{slate.950}',
              background: '{slate.500}'
            },
            tablist: {
              color: '{slate.50}',
              background: '{slate.700}'
            },
            tabpanel:
            {
              color: '{slate.50}',
              background: '{slate.700}'
            }
          },
          fileupload:
          {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          treeselect:
          {
            background: '{slate.900}',
            color: '{slate.50}',

          },
          tree:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            node: {
              hover: {
                background: '{slate.500}',
              },
              background: '{slate.900}',
              color: '{slate.50}',
              content: {
                background: '{slate.900}',
                color: '{slate.50}',

              }
            }
          },
          inputnumber:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            placeholder:
            {
              color: '{slate.300}',
            }
          },
          inputtext:
          {
            background: '{slate.900}',

            color: '{slate.50}',
            placeholder:
            {
              background: '{slate.800}',
              color: '{slate.300}',
            },
            disabled:
            {
              background: '{slate.850}',
              color: '{slate.100}',
            }
          },
          paginator:
          {
            background: '{slate.700}',
            color: '{surface.0}',
            nav: {
              button: {
                color: '{slate.0}',
                background: '{slate.700}',
                hover: {
                  background: '{slate.500}',
                }
              }
            },
            current:
            {
              nav: {
                button: {
                  color: '{slate.50}',
                  background: '{slate.500}',
                  hover: {

                  }

                }
              },
              page:
              {
                report: {
                  color: '{slate.50}'
                }
              }
            }



          },
          datepicker:
          {
            color: '{surface.50}',
            header:
            {
              background: '{slate.300}',

            },
            day: {
              background: '{surface.700}',
              color: '{surface.0}'
            },
            month: {
              background: '{surface.700}',
              color: '{surface.0}'
            },
            year: {
              background: '{surface.700}',
              color: '{surface.0}'
            },
            dropdown:
            {
              background: '{slate.700}',
              color: '{surface.50}',
              active:
              {
                background: '{zinc.500}',
                color: '{zinc.50}',
              }
            }

          },
          textarea:
          {
            background: '{slate.900}',
            color: '{slate.50}',
          },





          select:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            Overlay:
            {
              background: '{slate.800}',
              color: '{slate.50}',
            },
            placeholder:
            {
              background: '{slate.800}',
              color: '{slate.50}',
            },
            item:
            {
              background: '{slate.900}',
              color: '{slate.0}',
            },
            option:
            {
              focus:
              {
                background: '{slate.600}',
                color: '{slate.50}',
              },
              background: '{slate.900}',
              color: '{slate.0}',
              selected:
              {
                background: '{slate.800}',
                color: '{slate.0}',

              }
            }


          },
          multiselect:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            label:
            {
              background: '{slate.900}',
              color: '{slate.50}'
            },
            placeholder:
            {
              color: '{slate.100}',
              background: '{slate.900}',
            },
            Overlay:
            {
              background: '{slate.800}',
              color: '{slate.50}',
            },
            item:
            {
              background: '{slate.900}',
              color: '{slate.0}',
              hover:
              {
                background: '{slate.500}',
                color: '{slate.0}',
              }
            },
            option:
            {
              background: '{slate.900}',
              color: '{slate.0}',
              focus:
              {
                background: '{slate.600}',
                color: '{slate.50}',
              },
              selected:
              {
                background: '{slate.800}',
                color: '{slate.0}',
              }
            }

          },
          dialog:
          {
            background: '{zinc.600}',
            color: '{zinc.50}',
            border:
            {
              color: '{zinc.700}',
            },
            css: ({ dt }) => `
              .p-dialog-header {
                  background: var(--p-surface-600);
              }
              `
          },
          treetable:
          {
            body: {
              cell:
              {
                padding: 'var(--paddingControlCell)',
                background: '{zinc.700}',
                color: '{zinc.50}',
                border: {
                  color: '{slate.500}',
                },
                hover:
                {
                  background: '{zinc.200}',
                  color: '{zinc.900}',
                }
              }
            },
            row:
            {
              background: '{zinc.700}',
              color: '{zinc.50}',
              hover:
              {
                background: '{zinc.200}',
                color: '{zinc.900}',
              }
            },
            header: {
              background: '{zinc.700}',
              color: '{zinc.50}',
              cell:
              {
                padding: 'var(--paddingControlCell)',
                background: '{zinc.700}',
                color: '{zinc.50}'
              }
            }
          },

          checkbox:
          {
            background: '{zinc.400}',
          },
          radiobutton:
          {
            background: '{zinc.400}',
          },

          toolbar:
          {
            background: '{slate.900}',
            color: '{slate.50}',
            border:
            {
              color: '{slate.700}',
            },
          },
          menubar:
          {
            border:
            {
              color: '{slate.700}',
            },
            background: '{slate.900}',
            color: '{slate.50}',
            label:
            {
              background: '{slate.700}',
              color: '{slate.50}',
            },
            item:
            {
              background: '{slate.900}',
              color: '{slate.50}',
              focus:
              {
                background: '{slate.600}',
                color: '{slate.50}',
              },
              label:
              {
                background: '{slate.700}',
                color: '{slate.50}',
              }
            },
            submenu:
            {
              background: '{slate.900}',
              border:
              {
                color: '{slate.700}',
              },
              color: '{slate.50}',
              list:
              {
                background: '{slate.900}',
                color: '{slate.50}',
                border:
                {
                  color: '{slate.700}',
                },
              }
            }
          },
          panel:
          {
            background: '{slate.700}',
            color: '{slate.100}',

            border: {
              color: '{slate.700}'
            },
            header:
            {
              background: '{slate.700}',
              color: '{slate.100}',
              border: {
                color: '{slate.700}'
              }
            }
          },
          button: {

          },
          accordion:
          {
            header: {
              color: '{slate.100}',
              background: '{slate.800}',
              hover:
              {
                color: '{slate.100}',
                background: '{slate.600}',
              },
              active:
              {
                color: '{slate.100}',
                background: '{slate .700}',
                hover:
                {
                  color: '{slate.100}',
                  background: '{slate.500}',
                },
              }

            },
            content: {
              color: '{slate.50}',
              background: '{slate.900}'
            }
          },
        },
        navigation: {
          list: {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          item: {
            background: '{slate.900}',
            color: '{slate.50}',
          },
          submenuLabel: {
            background: '{slate.800}',
            color: '{slate.50}',
          },
          submenuIcon: {
            background: '{slate.700}',
            color: '{slate.50}',
            hover:
            {
              color: '{indigo.50}',
            }
          }
        },

        root: {
          editBackground: '{green.950}',
          background: '{surface.950}',
          checkedBackground: '{surface.850}',
          hoverBackground: '{surface.800}',
          borderColor: '{surface.900}',
          color: '{surface.50}',
          hoverColor: '{surface.500}',
          checkedColor: '{surface.0}',
          checkedBorderColor: '{surface.800}',

        },
        primary: palette('{indigo}'),
        highlight: {
          background: 'rgba(250, 250, 250, .16)',
          focusBackground: 'rgba(250, 250, 250, 0.5)',
          color: 'rgba(255,255,255,.87)',
          focusColor: 'rgba(255,255,255,.87)'
        },
        surface: {
          0: 'rgba(255,255,255,.87)',
          50: '{slate.50}',
          100: '{slate.100}',
          200: '{slate.200}',
          300: '{slate.300}',
          400: '{slate.400}',
          500: '{slate.500}',
          600: '{slate.600}',
          700: '{slate.700}',
          800: '{slate.800}',
          850: '{slate.850}',
          900: '{slate.900}',
          950: '{slate.950}'
        },
      }

    }
  }



});



export default Sortimentierenpreset;


